// Copyright (c) 2021 WiseTime. All rights reserved.

import React, { memo } from "react"
import ChartistGraph from "react-chartist"
import { IPieChartOptions } from "chartist"
import styled, { css } from "styled-components/macro"
import SvgIcon from "features/shared/SvgIcon"

const SharedIcon = css`
  @media (max-width: ${({ theme }): string => theme.screen.sm}) {
    margin-left: 1rem;
  }
`

const StyledPendingIcon = styled(SvgIcon)`
  ${SharedIcon};
  fill: ${({ theme }): string => theme.colors.emerald};
`

const StyledChartistGraph = styled(ChartistGraph)`
  ${SharedIcon};

  .ct-series.ct-series-a {
    fill: ${({ theme }): string => theme.colors.emerald};
    stroke: ${({ theme }): string => theme.colors.gallery};
    stroke-width: .5px;
  }
  
  .ct-series.ct-series-b {
    fill: ${({ theme }): string => theme.colors.indigo};
    stroke-width: 0;
  }
`

const options: IPieChartOptions = {
  chartPadding: 0,
  width: "17px",
  height: "17px",
  showLabel: false,
}

type Props = {
  totalPosted: number,
  totalUnposted: number,
}

const WeekDayTabStateIcon = ({
  totalPosted,
  totalUnposted,
}: Props): React.ReactElement<Props> | null => {
  if (totalPosted === 0 && totalUnposted === 0) {
    return null
  }

  if (totalPosted > 0 && totalUnposted === 0) {
    return <StyledPendingIcon name="check-circle"/>
  }

  const data = {
    labels: ["totalPosted", "totalUnposted"],
    series: [totalPosted, totalUnposted],
  }

  return (
    <StyledChartistGraph data={data} options={options} type="Pie"/>
  )
}

export default memo(WeekDayTabStateIcon)
